module.exports = __webpack_public_path__ + "media/images/sp/specials/fair/bg_03-bc82af135db15799f89e433f8466c45e.jpg";